import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { MIHttpClientService } from '../../shared/mi-http-client.service';
import { IGroup } from './group';
import { UsersService } from '../users.service';
import { sortByField } from '../../shared/custom-rxjs-operators';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {

  constructor(
    private miClient: MIHttpClientService,
    private usersService: UsersService,
  ) {
  }

  getAllGroups(): Observable<IGroup[]> {
    return this.miClient.get<IGroup[]>('groups/allGroups');
  }

  getMyGroups(): Observable<IGroup[]> {
    return this.miClient.get<IGroup[]>('groups/myGroups').pipe(sortByField('name'));
  }

  createGroup(group: any): Observable<any> {
    return this.miClient.post('groups', group);
  }

  getGroupData(id: number): Observable<any> {
    const group$ = this.miClient.get('groups/' + id);
    const users$ = this.usersService.getOrgUsers();
    return forkJoin([group$, users$]);
  }

  updateGroup(group: any): Observable<any> {
    return this.miClient.post('groups/' + group.id, group);
  }

  deleteGroup(id: any) {
    return this.miClient.delete('groups/' + id);
  }

}
